import React from 'react';
import { Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@mui/material';
import { IAttentionBoxProps } from './types/attention-box-props';
import BoxResult from './types/box-result-enum';


function AttentionBox({
  closeHandler: attentionBoxCloseHandler,
  message,
  isBoxOpen,
  title
}: IAttentionBoxProps) {
  return (
    <Dialog
      open={isBoxOpen}
      onClose={() => attentionBoxCloseHandler(BoxResult.YES)}
      aria-labelledby='attention-box-title'
      aria-describedby='attention-box-description'
      id='attention-box-dialog'
    >
      <DialogTitle id='attention-box-title'>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id='attention-box-description'>
          {message}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          color='primary'
          variant='outlined'
          onClick={() => attentionBoxCloseHandler(BoxResult.YES)}
          autoFocus
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default AttentionBox;
